<div class="uploader-modal">
  <div class="uploader-modal-header">
    <h2>{{ "ClientApp.FrontOffice.Portal.ItemImage.UploadImage" | translate }}</h2>
    <button (click)="close()"><i class="icon-close-o"></i></button>
  </div>

  <div class="uploader-modal-body">
    <form>
      <div class="main-image">
        <div class="main-image-img">
          <img #mainImageElement [src]="imagePaths ? imagePaths : 'assets/images/item-placeholder.png'" />
        </div>
        <div class="item-detail">
          <h3>{{ "ClientApp.FrontOffice.Portal.ItemImage.ProductName" | translate }}: {{ item.Title }}</h3>
          <span>{{ "ClientApp.FrontOffice.Portal.ItemImage.ProductCode" | translate }}: {{ item.Code }}</span>
          <button (click)="MainImage.click()">{{ "ClientApp.FrontOffice.Portal.ItemImage.UploadOriginalImage" | translate }}</button>
        </div>
        <input #MainImage (change)="onMainImageChange($event)" type="file" accept="image/png/jpeg/jpg" />
      </div>
      <div class="slide-image">
        <input #SlideImage (change)="onSlideImageChange($event)" type="file" accept="image/png/jpeg/jpg" />
        <div class="slide-image-add" (click)="SlideImage.click()">
          <i class="icon-add_photo_alternate-o"></i>
          <span>{{ "ClientApp.FrontOffice.Portal.ItemImage.AddSlide" | translate }}</span>
        </div>
        <ng-container *ngIf="slideImages.length">
          <div class="slide-image-img" *ngFor="let slide of slideImages">
            <img [src]="slide.src" />
            <button (click)="removeSlide(slide)">
              <i class="icon-close-o"></i>
            </button>
          </div>
        </ng-container>
      </div>
    </form>
  </div>

  <div class="uploader-modal-footer">
    <button (click)="close()">{{ "ClientApp.FrontOffice.Portal.ItemImage.OptOut" | translate }}</button>
    <button (click)="onSubmit()">{{ "ClientApp.FrontOffice.Portal.ItemImage.Save" | translate }}</button>
  </div>
</div>
